<template>
  <IframeCmp type="116" />
</template>

<script>
import IframeCmp from './cmp/IframeCmp';

export default {
  // 业务总览明细
  name: 'DailyCollectionReceivableReportBusiness',

  components: {
    IframeCmp
  },
  data() {
    return {

    };
  }
};
</script>

<style scoped></style>
